 const BCR = process.env.VUE_APP_BCR_BURN_ADDRESS;
 export default BCR